<template>
  <div class="pa-4" v-allowed="'manage_videos_data'">
    <v-card class="bjjlink-card pa-3" elevation="0" outlined>
      <v-card-actions>
        <div class="ml-3">
          {{ $t('message.filter_videos') }}
        </div>
        <v-spacer></v-spacer>
        <v-btn class="mr-2" @click="navigateTo({ name: 'managevideo', params: { videoId: 'new_admin_video' } })" small
          elevation="0" right outlined color="primary">
          {{ $t('message.add') }}
        </v-btn>
      </v-card-actions>
      <v-card-text class="pb-0">
        <v-row>
          <v-col class="pb-0" cols="12" sm="12" md="6">
            <v-text-field outlined dense v-model="titleFilter" :label="$t('message.title')"
              :clearable="true"></v-text-field>
          </v-col>
          <v-col class="pb-0" cols="12" sm="12" md="6">
            <category-combo v-model="categoryFilter" :label="$t('message.category')" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <div class="pa-4 mt-2">
      <v-row>
        <template v-for="v in videos">
          <v-col v-if="v.title" cols="12" xs="12" lg="3" fill-height :key="'academy_video' + v._id"
            @click="goToVideo(v._id)">
            <v-card elevation="0" class="clickable" outlined>
              <v-card-text class="text-subtitle-2 text-truncate pa-3">
                {{ v.title }}
              </v-card-text>
              <div class="video-square" v-if="v.ready">
                <ImageDisplay :src="v.thumbnail"></ImageDisplay>
              </div>
              <div v-else-if="v.encodingError" class="video-square text-center">
                <v-icon size="80" color="error">mdi-close-circle-outline</v-icon>
                <div class="text-caption">
                  {{ $t('message.encoding_error') }}
                </div>
              </div>
              <div v-else class="video-square text-center pt-4">
                <v-progress-linear height="100" indeterminate color="secondary">{{ $t('message.processing')
                }}</v-progress-linear>
              </div>
              <v-icon v-if="v.private" size="20" class="video-visibility">mdi-eye-off-outline</v-icon>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </div>
    <div v-if="loading">
      <circles-loader></circles-loader>
    </div>
    <div class="text-center mt-4">
      <v-btn small elevation="0" @click="searchMoreVideos" color="terciary" :disabled="!viewMore">{{
        $t('message.view_more') }}</v-btn>
    </div>
  </div>
</template>

<script>
import CirclesLoader from "@/components/displays/CirclesLoader.vue";
import CategoryCombo from "@/components/inputs/VideoCategoryCombo.vue";
import Api from "@/services/Api";

export default {
  data() {
    return {
      loading: false,
      videos: null,
      viewMore: false,
      titleFilter: null,
      tagsFilter: null,
      categoryFilter: null,
      pointer: 0
    };
  },
  components: {
    CirclesLoader,
    CategoryCombo,
  },
  created() {
    this.filter(false);
  },
  watch: {
    titleFilter: {
      handler: function () {
        this.pointer = 0;
        this.filter();
      }
    },
    tagsFilter: {
      handler: function () {
        this.pointer = 0;
        this.filter();
      }
    },
    categoryFilter: {
      handler: function () {
        this.pointer = 0;
        this.filter();
      }
    }
  },
  methods: {
    searchMoreVideos() {
      this.filter(true);
    },
    goToVideo(id) {
      this.navigateTo({ name: "managevideo", params: { videoId: id } });
    },
    filter(append) {
      if (!this.loading) {
        this.viewMore = false;
        if (!append) {
          this.videos = [];
          this.pointer = 0;
        }
        this.loading = true;
        var params = {};
        if (this.titleFilter && this.titleFilter != "")
          params["title"] = this.titleFilter;
        if (this.categoryFilter && this.categoryFilter != "")
          params["category"] = this.categoryFilter;
        if (this.tagsFilter && this.tagsFilter.length > 0)
          params["tags"] = this.tagsFilter;
        params["pointer"] = this.pointer;
        Api()
          .post("videos/admins/" + this.$store.state.managedAcademy + '/search', params)
          .then(response => {
            const data = response.data;
            this.videos = this.videos.concat(data.videos);
            this.loading = false;
            this.pointer = this.pointer + data.count;
            if (data.count >= this.searchesLimit) this.viewMore = true;
          })
          .catch(e => {
            this.loading = false;
            if (e)
              this.showAlert("error", "Oops!", "Looks like you should not be here.");
          });
      }
    }
  }
};
</script>

<style scoped>
.video-visibility {
  position: absolute;
  right: 0;
  margin-top: -20px;
  z-index: 2
}

.video-image {
  position: absolute;
  max-width: 100%;
  width: 100%;
  max-height: 190px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.video-square {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 190px;
  /* Max desired height */
  width: 100%;
  overflow: hidden;
  /* Optional: to see the bounds */
}

.video-square img {
  height: 100%;
  width: auto;
  object-fit: contain;
}
</style>